import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { useDropdownFeatures } from '../DropdownMenu/index.js';
import { genericMemo } from '../../utils/index.js';
import Popup from '../Popup/index.js';
import QuickActionButton from '../QuickActionButton/index.js';
import styles from './styles.css.js';

function QuickActionDropdownMenu(props) {
  const {
    className,
    children,
    label,
    variant = 'secondary',
    popupClassName,
    popupPlacementDirection,
    popupContentClassName,
    popupMatchesParentWidth,
    persistent = false,
    componentRef,
    ...otherProps
  } = props;
  const {
    buttonRef,
    popupRef,
    showPopup,
    setShowPopup,
    handleButtonClick
  } = useDropdownFeatures(persistent);
  React.useEffect(() => {
    if (componentRef) {
      componentRef.current = {
        setShowPopup
      };
    }
  }, [componentRef, setShowPopup]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuickActionButton, _extends({
    name: undefined,
    elementRef: buttonRef,
    className: className,
    variant: variant,
    onClick: handleButtonClick
  }, otherProps), label), /*#__PURE__*/React.createElement(Popup, {
    parentRef: buttonRef,
    className: _cs(styles.popup, popupClassName),
    contentClassName: popupContentClassName,
    show: showPopup,
    elementRef: popupRef,
    freeWidth: !popupMatchesParentWidth,
    placementDirection: popupPlacementDirection
  }, children));
}

var index = genericMemo(QuickActionDropdownMenu);

export { index as default };
//# sourceMappingURL=index.js.map
